<template>
	<div>
		<v-container fill-height class="d-flex justify-center" style="height: 100vh">잠시만 기다려주세요</v-container>
	</div>
</template>

<script>
	export default {
		name: 'Waiting',
	};
</script>

<style></style>
